import { createAsyncThunk } from "@reduxjs/toolkit";
import { AddPricingPayload, PricingData, PricingResponse, PricingSearchParams, PricingSearchResult } from "../../types/pricingType";
import customFetch from "../../util/config/axiosConfig";
import { ApiResponse } from "../../types/responseType";
import { CheckoutOrder, CheckoutPayload, VerifyPaymentPayload } from "../../types/pricingType";

export const fetchPricing = createAsyncThunk<
  PricingData,
  void,
  { rejectValue: string }
>(
  "pricing/fetchPricing",
  async (_, thunkAPI) => {
    try {
      const response = await customFetch.get<PricingResponse>("/api/v1/whatsapp/pricing");

      if (response.data.status !== 1) {
        throw new Error(response.data.error || "Failed to fetch pricing");
      }

      return response.data.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "Failed to fetch pricing");
    }
  }
);

export const fetchPricingSearch = createAsyncThunk<
  PricingSearchResult,
  PricingSearchParams,
  { rejectValue: string }
>(
  "pricing/fetchPricingSearch",
  async (params, thunkAPI) => {
    try {
      const { page = 0, size = 10, ...filters } = params;
      const response = await customFetch.post<ApiResponse<PricingSearchResult>>(
        `/api/pricing/search?page=${page}&size=${size}`,
        filters
      );

      if (response.data.status !== 1) {
        throw new Error(response.data.error?.message || "Failed to fetch pricing");
      }

      return response.data.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "Failed to fetch pricing");
    }
  }
);

export const addPricing = createAsyncThunk<
  void,
  AddPricingPayload,
  { rejectValue: string }
>(
  "pricing/addPricing",
  async (payload, thunkAPI) => {
    try {
      const response = await customFetch.post<ApiResponse<null>>(
        "/api/pricing",
        payload
      );

      if (response.data.status !== 1) {
        throw new Error(response.data.error?.message || "Failed to add pricing");
      }
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "Failed to add pricing");
    }
  }
);

export const createSubscriptionCheckout = createAsyncThunk<
    CheckoutOrder,
    CheckoutPayload,
    { rejectValue: string }
>("pricing/createSubscriptionCheckout", async (payload, thunkAPI) => {
    try {
        const response = await customFetch.post("/api/subscriptions/checkout", payload);
        const body = response.data;

        if (body?.status !== undefined && body.status !== 1) {
            throw new Error(body.error?.message || "Failed to create checkout");
        }
        // supports both { status, data: {...} } and a raw order object
        return (body?.data ?? body) as CheckoutOrder;
    } catch (error: any) {
        return thunkAPI.rejectWithValue(
            error?.response?.data?.error?.message || error?.message || "Failed to create checkout"
        );
    }
});

export const verifySubscriptionPayment = createAsyncThunk<
    void,
    VerifyPaymentPayload,
    { rejectValue: string }
>("pricing/verifySubscriptionPayment", async (payload, thunkAPI) => {
    try {
        const response = await customFetch.post("/api/subscriptions/verify", payload);
        const body = response.data;

        if (body?.status !== undefined && body.status !== 1) {
            throw new Error(body.error?.message || "Payment verification failed");
        }
    } catch (error: any) {
        return thunkAPI.rejectWithValue(
            error?.response?.data?.error?.message || error?.message || "Payment verification failed"
        );
    }
});